import React, { useState } from "react";
export function Strengths({ values, icon, handleChange }) {
    // const [strengths, setStrengths] = useState<string[]>(values);
    const [tag, setTag] = useState("");
    const addStrength = () => {
        if (values && values.length < 5) {
            handleChange([...values, tag]);
            // setStrengths([...strengths, tag]);
            setTag("");
        }
    };
    return (React.createElement("div", { className: "w-full flex flex-wrap gap-2 items-center px-4 py-3 border bg-white border-neutralBlue1 rounded-md", style: { flexWrap: "wrap" } },
        values &&
            values.length > 0 &&
            values.map((strength, index) => (React.createElement("div", { className: "w-max bg-neutralBlue2 border border-neutralBlue1 flex items-center gap-2 py-2 px-4 rounded-full" },
                React.createElement("p", { className: "text-xs font-medium" }, strength),
                React.createElement("img", { src: icon, className: "w-2 cursor-pointer", onClick: () => handleChange(values.filter((i, idx) => idx !== index)) })))),
        React.createElement("input", { type: "text", placeholder: "Add Strengths", value: tag, maxLength: 20, className: "w-min max-w-[100px] text-sm placeholder:text-gray-400 placeholder:font-normal outline-none focus:outline-none", onChange: (e) => setTag(e.target.value), onKeyDown: (e) => e.key === "Enter" && addStrength() })));
}
